"use client"

import JoinPoln from "components/JoinPoln";
import PartnerContact from "components/PartnerContact";
import InfoCTA from "../../InfoCTA";


export default function CTA(props) {
    let {cta, reverse, className, siteConfig, questions} = props
    if (!cta) {

        return null
    }
    cta = {...cta}

    const containerClasses = `red-color ${className}`

    if (cta.type === "waitlist") {
        return <JoinPoln className={containerClasses} {...cta} reverse={reverse} logo={siteConfig?.logo}
                         questions={questions}/>
    }

    if (cta.type === "partner") {
        return <PartnerContact className={containerClasses} {...cta} reverse={reverse} logo={siteConfig?.logo}/>
    }

    if (cta.type === "link") {
        const {link} = cta
        if (!link) {
            return null
        }

        return <InfoCTA className={containerClasses} {...cta} reverse={reverse}/>
    }


    return null
}
